import { useMemo, useState } from "react";
import { merchItems, type MerchItem } from "@/mocks/fanCommunity";

const cats = ["全部", "应援周边", "生活周边", "限量特典"];

export default function MerchSection() {
  const [active, setActive] = useState("全部");

  const list: MerchItem[] = useMemo(
    () => (active === "全部" ? merchItems : merchItems.filter((m) => m.category === active)),
    [active]
  );

  return (
    <section id="merch" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              <i className="ri-shopping-bag-3-line" />
              粉丝周边 · 最新系列
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
              把热爱随身携带
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              从应援棒到生活小物，每一件周边都承载着与捷克有关的记忆。本站展示系列预告，正式购买请认准官方周边店铺。
            </p>
          </div>
          <div className="flex flex-wrap gap-2 lg:shrink-0">
            {cats.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  active === c
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div
          className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4"
          data-product-shop
        >
          {list.map((m) => (
            <article
              key={m.id}
              className="group flex flex-col overflow-hidden rounded-xl border border-background-200/80 bg-background-100 transition-transform duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="aspect-square w-full overflow-hidden">
                <img
                  src={m.image}
                  alt={`${m.name} 吃瓜捷克应援周边`}
                  title={`${m.name} - 吃瓜捷克周边`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4">
                <span className="text-xs text-foreground-500">{m.category}</span>
                <h3 className="mt-1 font-heading text-sm md:text-base font-semibold leading-snug text-foreground-950">
                  {m.name}
                </h3>
                <p className="mt-1.5 line-clamp-2 flex-1 text-xs md:text-sm leading-relaxed text-foreground-600">
                  {m.desc}
                </p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="font-heading text-base font-bold text-primary-600">{m.price}</span>
                  <span className="text-xs text-foreground-400">官方在售</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 flex items-center gap-1.5 text-xs text-foreground-500">
          <i className="ri-information-line" />
          周边图片与价格仅作系列展示，具体以官方周边店铺实际上架为准。
        </p>
      </div>
    </section>
  );
}